import type { DraftTable } from "../editor/types";

/**
 * The accessible name a canvas table exposes to AT and axe (Tech-decision "Keyboard & AT path"):
 * "Table 12, 2–4 covers, Terrasse". Composed from label + covers + zone so a screen-reader user can
 * navigate the plan by meaningful names — the reason table nodes stay real, labelable DOM elements.
 */
export function tableAccessibleName(
  table: DraftTable,
  zoneName: string,
  t: (key: string, opts?: Record<string, unknown>) => string,
): string {
  const base = t("floorPlan.canvas.tableName", {
    label: table.label,
    min: table.minCovers,
    max: table.maxCovers,
    zone: zoneName,
  });
  return table.retired ? t("floorPlan.canvas.tableNameRetired", { name: base }) : base;
}
